/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Dimas Zulfa Santana",
  title: "Hi, I'm Dimas Zulfa",
  subTitle: emoji(
    `A passionate Fullstack Developer 🚀 having an experience of building Web and Mobile applications with PHP, Flutter, Kotlin and some other cool libraries and frameworks.
    `
  ),
  resumeLink:
    "https://drive.google.com/drive/folders/1M4oZ3WcgoA3MInxCP2w0TkeSNdd587Zi?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/dimaszulfa",
  linkedin: "https://www.linkedin.com/in/dimas-zulfa-santana-506281205/",
  gmail: "dimaszulfa123@gmail.com",
  // gitlab: "https://gitlab.com/saadpasta",
  // facebook: "https://www.facebook.com/seiryuufrsty",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Language",
  subTitle: "Programming language used / Stack that i'm used : ",
  skills: [
    // emoji(
    //   "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    // ),
    // emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    // emoji(
    //   "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    // )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Flutter",
      fontAwesomeClassname: "fab fa-android"
    },
    {
      skillName: "Android",
      fontAwesomeClassname: "fab fa-android"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    // {
    //   skillName: "sass",
    //   fontAwesomeClassname: "fab fa-sass"
    // },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    // {
    //   skillName: "reactjs",
    //   fontAwesomeClassname: "fab fa-react"
    // },
    // {
    //   skillName: "nodejs",
    //   fontAwesomeClassname: "fab fa-node"
    // },
    // {
    //   skillName: "swift",
    //   fontAwesomeClassname: "fab fa-swift"
    // },
    // {
    //   skillName: "npm",
    //   fontAwesomeClassname: "fab fa-npm"
    // },
    {
      skillName: "PHP",
      fontAwesomeClassname: "fab fa-php"
    },
    {
      skillName: "PostgreSQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "MYSQL",
      fontAwesomeClassname: "fas fa-database"
    },
    // {
    //   skillName: "aws",
    //   fontAwesomeClassname: "fab fa-aws"
    // },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    // {
    //   skillName: "python",
    //   fontAwesomeClassname: "fab fa-python"
    // },
    // {
    //   skillName: "docker",
    //   fontAwesomeClassname: "fab fa-docker"
    // }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Langlangbuana University",
      logo: require("./assets/images/unla.png"),
      subHeader: "Teknik Informatika",
      duration: "Agustus 2018  - Agustus 2022",
      // desc: "Participated in the research of XXX and published 3 papers.",
      descBullets: [
         "Creating mobile applications using Java and Kotlin languages",
         "Build a web using PHP and the Codeigniter framework",
         "Designing database schema using ERD",
         "Designing and building applications using the SDLC method",
        
      ]
    },
    {
      schoolName: "SMKN 2 Baleendah",
      logo: require("./assets/images/logosmk2.png"),
      subHeader: "Teknik Komputer dan Jaringan",
      duration: "Mei 2015- Mei 2018",
      // desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
      descBullets: [
        "Creating server administration with Debian Linux including",
        "Configuring proxy (filtering, bandwidth, subnetting, proxy)",
        "Learn the C++ programming language",
        "Learn to assemble computers",
       ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Mobile Developer", //Insert stack or technology you have experience in
      progressPercentage: "80%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend API with Laravel ",
      progressPercentage: "60%"
    },
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Fullstack Developer",
      company: "PT. Maxistar Intermoda Indonesia",
      companylogo: require("./assets/images/maxi.webp"),
      date: "Feb 2024 – Present",
      // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
      
"Worked with software development and testing team members to design and develop robust",
"solutions to meet client requirements for functionality, scalability and performance.",
"Reviewed project specifications and designed technology solutions that met or exceededperformance expectations",
"Develop e-commerce and point of sales (POS) applications to support digital sales.",
"Contribute to developing Enterprise resource planning (ERP) applications",
"Developing an android application made using flutter to help sales in the digital field",
"Integrate applications with third parties such as Payment Method Service Provider via Xendit API, Whatsapp OTP service providers, Lion Parcel API and Firebase (Authentication, Messaging)"
      ]
    }
    ,
    {
      role: "Software Engineer",
      company: `PT Maxxima Innovative `,
      companylogo: require("./assets/images/maxxima.png"),
      date: "Feb 2023 – Feb 2024",
      // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Integrate fingerprint with application using socket.io (hardware solution fingerprint)",
        " Developing an application for attendance using flutter",
        " Developing SIAK Mobile with flutter BLoC",
         "Applying the BLOC pattern for mobile application development using the Flutter programming language",
         "Implement a clean architecture so that applications can be maintained easily",
         "Develop smartwatch mobile applications using the Java programming language.",
         "Design and build a REST API using the Laravel programming language",
         "Create a mobile application and implement a REST API using the Flutter programming language",
         "Database management using POSTGRESQL and MYSQL databases",
         "Releasing and deploying applications into VMware EXSI.",
      ]
    },
//     {
//       role: "Programer & Lab Assistant",
//       company: "SMK Putra Bahari",
//       companylogo: require("./assets/images/smkputrabahari.jpg"),
//       date: "May 2017 – May 2018",
//       // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
//       descBullets: [
//         "Building mobile and web applications related to bullying prevention using Flutter",
// "Build a network using MikroTik",
// "Create a Virtual Private Server application to create student report",
// "Creating Administrative Applications using the CodeIngiter 3 Framework and PHP",
// "Create a Local Web Server using Linux Debian 8",
// "Configure routers, switches according to the requirements required",
// "Configuring the CBT application for Computer-based Exams",
//       ]
//     },
    {
      role: "Android Developer Intern",
      company: " PT Telkom Indonesia",
      companylogo: require("./assets/images/telkom.png"),
      date: "Jan 2015 – Sep 2015",
      // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Build applications with the Scrum system development method",
        "Develop applications with the Kotlin programming language",
        "Implement SOLID principles to applications",
        "Using Gitlab as a tool for Versioning Control System VCS",
        "Using the Jira application to work with teams in project management",
        "Create a custom view that is intended to design views according to project needs",
      ]
    },
    {
      role: "Mobile Development Academy",
      company: " Google Bangkit Academy 2021",
      companylogo: require("./assets/images/bangkit.png"),
      date: "Feb 2021 – Jul 2021",
      // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Create a mobile application using the kotlin language",
        "Applying the SOLID Principle concept to the program to be built",
        "Building applications using the MVVM pattern",
        "Learn Android Jetpack Pro",
        "Working on Capstone project by collaborating with three learning paths; Mobile Development, Cloud Computing and Artificial Intelligence",
        
      ]
    },
    // {
    //   role: "IT Support Intern",
    //   company: "PT Dirgantara Indonesia",
    //   companylogo: require("./assets/images/ptdi.png"),
    //   date: "Jan 2015 – Sep 2015",
    //   // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    //   descBullets: [
    //     "Repairing problematic computer networks",
    //     "Creating a proxy as a way to secure connections from the threat of illegal data access using Linux Mint",
    //     "Connecting the user's computer to connect to the internet using a proxy",
    //     "Fixed a system that had problems when the user used it",
    //     "Perform antivirus installation and configuration to secure company computers",
    //     "Perform computer cleaning when a computer is infected with a virus",
    //   ]
    // }, 

  ]
};
const workExperiences2 = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    // {
    //   role: "IT Support Intern",
    //   company: "PT Dirgantara Indonesia",
    //   companylogo: require("./assets/images/ptdi.png"),
    //   date: "Jan 2015 – Sep 2015",
    //   // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    //   descBullets: [
    //     "Repairing problematic computer networks",
    //     "Creating a proxy as a way to secure connections from the threat of illegal data access using Linux Mint",
    //     "Connecting the user's computer to connect to the internet using a proxy",
    //     "Fixed a system that had problems when the user used it",
    //     "Perform antivirus installation and configuration to secure company computers",
    //     "Perform computer cleaning when a computer is infected with a virus",
    //   ]
    // }, 

  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Portofolio Aplikasi",
  subtitle: "Project that i have done",
  projects: [
    {
      image: require("./assets/images/onboard_aster.png"),
      detailImages: [
        require("./assets/images/onboard_aster.png"),
        require("./assets/images/splash_aster.png"),
        require("./assets/images/paket_wisata.png"),
        require("./assets/images/dashboard_aster.png"),
        require("./assets/images/detail_aster.png")
      ],
      projectName: "Asterdewi App",
      projectDesc: "aplikasi panduan wisata yang dirancang untuk memudahkan wisatawan menjelajahi destinasi terbaik di Adiluhur. Aplikasi ini menghadirkan pengalaman traveling yang lebih praktis, informatif, dan menyenangkan dengan fitur interaktif dan navigasi yang intuitif.",
      footerLink: [
        {
          name: "Kotlin",
          // url: "http://saayahealth.com/"
        },
        {
          name: "Firebase Authentication",
          // url: "http://saayahealth.com/"
        },
        {
          name: "Shared Preferences",
          // url: "http://saayahealth.com/"
        },
        {
          name: "Firebase Storage",
          // url: "http://saayahealth.com/"
        },
        {
          name: "Firebase Realtime Database",
          // url: "http://saayahealth.com/"
        },
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/dashboard_eco.png"),
      projectName: "Green Travel",
      projectDesc: "GreenTravel adalah aplikasi mobile yang dirancang untuk mendukung gaya hidup ramah lingkungan bagi para traveler. Aplikasi ini membantu pengguna menghitung jejak karbon dari perjalanan mereka, memberikan skor eco berdasarkan kebiasaan traveling, dan merekomendasikan cara untuk membuat perjalanan lebih ramah lingkungan.",
        detailImages: [
        require("./assets/images/splash_eco.png"),
        require("./assets/images/dashboard_eco.png"),
        require("./assets/images/profile_eco.png"),
        require("./assets/images/destination_eco.png"),
        require("./assets/images/login_eco.png"),
        require("./assets/images/achievment_eco.png"),
        require("./assets/images/register_eco.png"),
      ],
      footerLink: [
        {
          name: "Flutter",
          // url: "http://saayahealth.com/"
        },
        {
          name: "GetX",
          // url: "http://saayahealth.com/"
        },
        {
          name: "Shared Preferences",
          // url: "http://saayahealth.com/"
        },
        {
          name: "TMDB API",
          // url: "http://saayahealth.com/"
        },
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/dashboard_amgala.png"),
      projectName: "Amgala App",
      projectDesc: "AMGALA MERUPAKAN platform inovatif yang menghubungkan organisasi dan individu yang ingin berkontribusi dalam kegiatan sosial dan kemanusiaan. Aplikasi ini memudahkan para relawan menemukan peluang yang sesuai dengan minat dan keterampilan mereka, sekaligus membantu organisasi merekrut bantuan yang tepat secara efektif.",
         detailImages: [
        require("./assets/images/register_amgala.png"),
        require("./assets/images/volunteer_amgala.png"),
        require("./assets/images/dashboard_amgala.png"),
        require("./assets/images/detail_berita_amgala.png"),
        require("./assets/images/detail_inbox_amgala.png"),
      ],
      footerLink: [
        {
          name: "Flutter",
          // url: "http://saayahealth.com/"
        },
        {
          name: "Provider",
          // url: "http://saayahealth.com/"
        },
        {
          name: "Shared Preferences",
          // url: "http://saayahealth.com/"
        },
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/selfie_absenkiw.png"),
      projectName: "Absenkiw",
      projectDesc: "aplikasi absensi berbasis mobile yang dirancang untuk mempermudah karyawan, mahasiswa, atau anggota organisasi melakukan presensi secara cepat, akurat, dan fleksibel. Aplikasi ini menghilangkan kebutuhan absensi manual dan menghadirkan solusi modern yang lebih efisien dengan integrasi lokasi dan teknologi pengenalan wajah.",
        detailImages: [
        require("./assets/images/selfie_absenkiw.png"),
        require("./assets/images/dashboard_absenkiw.png"),
        require("./assets/images/presence_absenkiw.png"),
        require("./assets/images/history_absenkiw.png"),
        require("./assets/images/splash_absenkiw.png"),
      ],
      footerLink: [
        {
          name: "Flutter",
          // url: "http://saayahealth.com/"
        },
        {
          name: "GetX",
          // url: "http://saayahealth.com/"
        },
        {
          name: "Shared Preferences",
          // url: "http://saayahealth.com/"
        },
        {
          name: "TMDB API",
          // url: "http://saayahealth.com/"
        },
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/onboarding_limonia.png"),
      projectName: "Limonia App",
        detailImages: [
        require("./assets/images/onboarding_limonia.png"),
        require("./assets/images/register_limonia.png"),
        require("./assets/images/live_limonia.png"),
        require("./assets/images/notification_limonia.png"),
        require("./assets/images/user_limonia.png"),
        require("./assets/images/login_limonia.png"),
        
      ],
      projectDesc: "Aplikasi yang dirancang untuk membantu pemilik kolam ikan, baik skala kecil maupun besar, dalam memantau kualitas air secara real-time. Dengan fitur pemantauan pH, suhu, kadar oksigen, hingga tingkat kekeruhan, aplikasi ini memastikan kondisi kolam tetap optimal untuk pertumbuhan ikan yang sehat dan produktif.",
      footerLink: [
        {
          name: "Flutter",
          // url: "http://saayahealth.com/"
        },
        {
          name: "GetX",
          // url: "http://saayahealth.com/"
        },
        {
          name: "Shared Preferences",
          // url: "http://saayahealth.com/"
        },
        {
          name: "TMDB API",
          // url: "http://saayahealth.com/"
        },
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/movie_app.png"),
      projectName: "Movie App",
      projectDesc: "Application created to display movie and genre searches",
      footerLink: [
        {
          name: "Flutter",
          // url: "http://saayahealth.com/"
        },
        {
          name: "GetX",
          // url: "http://saayahealth.com/"
        },
        {
          name: "Shared Preferences",
          // url: "http://saayahealth.com/"
        },
        {
          name: "TMDB API",
          // url: "http://saayahealth.com/"
        },
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/presencia.png"),
      projectName: "Presencia",
      projectDesc: "Application for online attendance",
      footerLink: [
        {
          name: "Flutter",
          // url: "http://saayahealth.com/"
        },
        {
          name: "Rest API",
          // url: "http://saayahealth.com/"
        },
        {
          name: "Google Maps API",
          // url: "http://saayahealth.com/"
        },
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/sarang.png"),
      projectName: "Sarang App",
      projectDesc: "Application for finding a soul mate",
      footerLink: [
        {
          name: "Flutter",
          // url: "http://saayahealth.com/"
        },
        {
          name: "BLoC",
          // url: "http://saayahealth.com/"
        },
        {
          name: "Shared Preferences",
          // url: "http://saayahealth.com/"
        },
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/batik.png"),
      projectName: "Batik Nusantara",
      projectDesc: "Application to display information related to contemporary Indonesian batik",
      footerLink: [
        {
          name: "Kotlin",
          // url: "http://saayahealth.com/"
        },
        {
          name: "Firebase",
          // url: "http://saayahealth.com/"
        },
        {
          name: "XML Design",
          // url: "http://saayahealth.com/"
        },
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/simapara.png"),
      projectName: "Sistem Informasi Pariwisata",
      projectDesc: "Application to display information related to tourism in Indonesia",
      footerLink: [
        {
          name: "Java",
          // url: "http://saayahealth.com/"
        },
        {
          name: "Firebase",
          // url: "http://saayahealth.com/"
        },
        {
          name: "XML Design",
          // url: "http://saayahealth.com/"
        },
        //  you can add extra buttons here.
      ]
    },
 
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Certifications "),
  subtitle:
    "Certifications that I have done",

  achievementsCards: [
    {
      title: "Certified Secure Computer User (C/SCU)",
      // subtitle:
      //   "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/Ec_Council_Logo.png"),
      imageAlt: "Certified Secure Computer User (C/SCU)",
      footerLink: [
        {
          name: "Certification Link",
          url: "https://aspen.eccouncil.org/Verify"
        },
        {
          name: "Certif Number : ECC5364982710",
          url: "#"
        },
      ]
    },
    {
      title: "Become a Flutter Developer Expert",
      // subtitle:
      //   "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/dicoding.png"),
      imageAlt: "Become a Flutter Developer Expert",
      footerLink: [
        {
          name: "Certification Link",
          url: "https://www.dicoding.com/certificates/1OP8NJM41XQK"
        },
      ]
    },
    {
      title: "Learn Flutter Application Fundamentals",
      // subtitle:
      //   "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/dicoding.png"),
      imageAlt: "Learn Flutter Application Fundamentals",
      footerLink: [
        {
          name: "Certification Link",
          url: "https://www.dicoding.com/certificates/JLX125J45Z72"
        },
      ]
    },
    {
      title: "Getting Started Programming with Dart",
      // subtitle:
      //   "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/dicoding.png"),
      imageAlt: "Getting Started Programming with Dart",
      footerLink: [
        {
          name: "Certification Link",
          url: "https://www.dicoding.com/certificates/4EXGK387GZRL"
        },
      ]
    },
    {
      title: "Learn to Make Flutter Apps for Beginners",
      // subtitle:
      //   "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/dicoding.png"),
      imageAlt: "Learn to Make Flutter Apps for Beginners",
      footerLink: [
        {
          name: "Certification Link",
          url: "https://www.dicoding.com/certificates/N9ZOO2QY8ZG5"
        },
      ]
    },
    {
      title: "Learn Git",
      // subtitle:
      //   "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/progate.png"),
      imageAlt: "Learn Git",
      footerLink: [
        {
          name: "Certification Link",
          url: "https://progate.com/course_certificate/49154003qp9vqg"
        },
      ]
    },
    {
      title: "IT Support Google Specialization",
      // subtitle:
      //   "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/coursera.png"),
      imageAlt: "IT Support Google Specialization",
      footerLink: [
        {
          name: "Certification Link",
          url: "https://www.coursera.org/account/accomplishments/specialization/certificate/YSJRWXLTHP3C"
        },
      ]
    },
    {
      title: "Learn to Make Android Applications for Beginners",
      // subtitle:
      //   "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/dicoding.png"),
      imageAlt: "Learn to Make Android Applications for Beginners",
      footerLink: [
        {
          name: "Certification Link",
          url: "https://www.dicoding.com/certificates/KEXL4233WXG2"
        },
      ]
    },
    {
      title: "Learn Android Application Fundamentals",
      // subtitle:
      //   "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/dicoding.png"),
      imageAlt: "Learn Android Application Fundamentals",
      footerLink: [
        {
          name: "Certification Link",
          url: "https://www.dicoding.com/certificates/RVZK459MQPD5"
        },
      ]
    },
    {
      title: "Learn about Kotlin",
      // subtitle:
      //   "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/solo_learn.png"),
      imageAlt: "Learn about Kotlin",
      footerLink: [
        {
          name: "Certification Link",
          url: "https://www.sololearn.com/certificates/course/en/21049580/1160/landscape/png"
        },
      ]
    },
   
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me"),
  subtitle:
    "Let's discuss a project.",
  number: "6289662988939",
  email_address: "dimaszulfa123@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  workExperiences2,
  openSource,
  achievementSection,
  bigProjects,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
